module.exports = __webpack_public_path__ + "media/videos/term-bg-6-146d8d4d.jpg";